import { Temporal } from "temporal-polyfill";

const MARKET_TIMEZONE = "America/New_York";
const STOCK_DAILY_HISTORY_DELAY_DAYS = 1;
const DELAYED_MARKET_DATA_MS = 16 * 60_000;

interface FormatChartHistoryEndDateParams {
  periodToMs: number;
  resolution: string;
  crypto: boolean;
  isUnlimited: boolean;
  nowMs?: number;
}

export const formatStockDailyHistoryEndDate = (toMs: number): string => {
  const targetDate = Temporal.Instant.fromEpochMilliseconds(toMs)
    .toZonedDateTimeISO("UTC")
    .subtract({ days: STOCK_DAILY_HISTORY_DELAY_DAYS })
    .toPlainDate();

  return targetDate
    .toZonedDateTime({
      timeZone: MARKET_TIMEZONE,
      plainTime: Temporal.PlainTime.from("00:00"),
    })
    .toString({ timeZoneName: "never" });
};

export const formatChartHistoryEndDate = ({
  periodToMs,
  resolution,
  crypto,
  isUnlimited,
  nowMs = Date.now(),
}: FormatChartHistoryEndDateParams): string => {
  const cappedToMs = Math.min(periodToMs, nowMs);

  if (resolution === "1D" && !crypto) {
    return formatStockDailyHistoryEndDate(cappedToMs);
  }

  const delayMs = isUnlimited ? 0 : DELAYED_MARKET_DATA_MS;
  return new Date(cappedToMs - delayMs).toISOString();
};
